export default function getLocation(slug) {
    return new Promise(function (resolve, reject) {
        if (!slug || !process.env.BASE_FNS_URL) {
            reject('Unable to fetch location data.');
            return;
        }

        // @TODO: Cache these results to avoid duplicate fetches
        fetch(process.env.BASE_FNS_URL + '/api/getLocation?id=' + slug)
            .then((response) => {
                return response.json();
            })
            .then(function (data) {
                resolve(data);
            })
            .catch(function (error) {
                reject(error);
            });
    });
}
